function mixin(target, source) {
  for (const prop in source) {
    if (source.hasOwnProperty(prop)) {
      if (target.hasOwnProperty(prop)) {
        target[`__original_${prop}`] = target[prop];
      }
      target[prop] = source[prop];
    }
  }
  return target;
}

export { mixin };
